import { styled } from '@mui/material';
import { useRef } from 'react';

import {
  useQueryActiveCases,
  useQueryAircraftStatuses,
  AircraftCards,
} from '#features';
import { Loader } from '#shared';

import { Widget } from '../base';

import type { WidgetConfigBase, WidgetProps } from '#features';

export interface WidgetAirFleetTrackerProps {
  maxRows?: number;
}

type Settings = WidgetAirFleetTrackerProps & Record<string, unknown>;

const config: WidgetConfigBase<Settings> = {
  maxRows: {
    type: 'number',
    label: 'Max Rows',
    defaultValue: 0,
    min: 0,
    step: 1,
  },
};

const Root = styled(Widget)(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
}));

export const WidgetAirFleetTracker = ({
  instance,
  showSettingsButton,
  className,
}: WidgetProps<Settings>) => {
  const { data: activeCases, isLoading: isLoadingActiveCases } =
    useQueryActiveCases();
  const { data: aircraftsList, isLoading: isLoadingAircraftStatuses } =
    useQueryAircraftStatuses();
  const showLoader = isLoadingActiveCases || isLoadingAircraftStatuses;

  const ref = useRef<HTMLDivElement>(null);

  return (
    <Root
      ref={ref}
      config={config}
      instance={instance}
      showSettingsButton={showSettingsButton}
      className={className}
    >
      {resolved =>
        showLoader ? (
          <Loader />
        ) : (
          <AircraftCards
            {...(resolved as Settings)}
            renderInsideWidget
            aircraftsList={aircraftsList}
            activeCases={activeCases}
            // backendNetworkError={backendNetworkError}
          />
        )
      }
    </Root>
  );
};

WidgetAirFleetTracker.config = config;
